const PageTemplateType = require('constants/PageTemplateType');

const SpaTemplatesInfo = [
    {
        template: PageTemplateType.ProductPage,
        pageName: 'product',
        killSwitchName: 'spaEnabledProduct',
        url: '/product/'
    },
    {
        template: PageTemplateType.NthCategory,
        pageName: 'nthCategory',
        killSwitchName: 'spaEnabledCategory',
        url: '/shop/'
    },
    {
        template: PageTemplateType.BrandNthCategory,
        pageName: 'nthBrand',
        killSwitchName: 'spaEnabledBrand',
        url: '/brand/'
    },
    {
        template: PageTemplateType.Search,
        pageName: 'search',
        killSwitchName: 'spaEnabledSearch',
        url: '/search'
    },
    {
        template: PageTemplateType.Search,
        pageName: 'sale',
        killSwitchName: 'spaEnabledSearch',
        url: '/sale'
    },
    {
        template: PageTemplateType.Basket,
        pageName: 'basket',
        pagePropName: 'basket',
        killSwitchName: 'spaEnabledBasket',
        url: '/basket'
    },
    {
        template: PageTemplateType.RwdContentStore,
        pageName: 'contentStoreData',
        killSwitchName: 'spaEnabledBeautyOffer',
        url: '/beauty/beauty-offers'
    },
    {
        template: PageTemplateType.BuyPage,
        pageName: 'buyPage',
        killSwitchName: 'spaEnabledBuyPage',
        url: '/buy/'
    },
    {
        template: PageTemplateType.Homepage,
        pageName: 'home',
        killSwitchName: 'spaEnabledHomePage',
        url: /^\/$/
    }
    // uncomment with story EXP-5719 in .03
    // {
    //     template: PageTemplateType.Content,
    //     pageName: 'content',
    //     // TODO When (EXP-5713) is complete, update killSwitchName
    //     killSwitchName: 'spaEnabledBeautyOffer',
    //     url: '/beauty/beauty-best-sellers'
    // },
    // {
    //     template: PageTemplateType.Content,
    //     pageName: 'content',
    //     // TODO When (EXP-5713) is complete, update killSwitchName
    //     killSwitchName: 'spaEnabledBeautyOffer',
    //     url: /\/beauty\/best-selling\-.+/
    // },
    // {
    //     template: PageTemplateType.Content,
    //     pageName: 'content',
    //     // TODO When (EXP-5713) is complete, update killSwitchName
    //     killSwitchName: 'spaEnabledBeautyOffer',
    //     url: /\/beauty\/new\-.+/
    // }
];

module.exports = { SpaTemplatesInfo };
